/**
 * Submit User Report UseCase
 *
 * Submits a user report to Firestore via ReportService.
 *
 * Pattern from Flutter: ReportRepository.reportUser
 * Source: lib/data/repository/report_repository.dart
 */

import { reportService } from '@/domain/services/report/reportService';

export class SubmitUserReportUseCase {
  /**
   * Submit a report against a user
   *
   * @param reportItemId - ID of the selected UserReportItem (leaf item)
   * @param peerUserId - Firebase ID of the reported user
   * @param comment - Optional free text comment (max 200 chars)
   * @returns Promise<boolean> - Success status
   */
  async execute(
    reportItemId: string,
    peerUserId: string,
    comment: string
  ): Promise<boolean> {
    return reportService.submitUserReport(reportItemId, peerUserId, comment);
  }
}

export const submitUserReportUseCase = new SubmitUserReportUseCase();
